module.exports = __webpack_public_path__ + "img/logo.631bde89.svg";